import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "py-3 pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_3 = { class: "space-y-6 ml-4" }
const _hoisted_4 = { class: "flex gap-y-6 flex-row flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_ctx.detailData.partnerType.toLowerCase() === 'pos')
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Title, {
            label: _ctx.$t('Kode Referral')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_DataWrapper, {
              class: "w-6/12",
              label: _ctx.$t('Kode Referral'),
              value: _ctx.detailData.partnerReferralCode
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-6/12",
              label: _ctx.$t('Kode Referrer'),
              value: _ctx.detailData.partnerReferrerCode
            }, null, 8, ["label", "value"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}